import { render, staticRenderFns } from "./Resumen.html?vue&type=template&id=51960274&scoped=true&"
import script from "./Resumen.js?vue&type=script&lang=js&"
export * from "./Resumen.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51960274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/SVN/Software/WebPages/VueAnsul/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VAvatar,VBtn,VCard,VCardActions,VChip,VContainer,VDataTable,VFlex,VIcon,VLayout,VSpacer,VSwitch,VTextField,VToolbar,VToolbarTitle})
